import React from "react";
import NotificationsPage from "../NotificationsPage";

/**
 * Admin variant of the shared Notifications page.
 *
 * Wraps the shared NotificationsPage in a container that carries the
 * legacy ``data-testid="admin-notifications-page"`` so existing admin
 * tests and selectors keep working alongside the new shared
 * ``data-testid="notifications-page"``.
 */
export default function AdminNotificationsPage() {
  return (
    <div data-testid="admin-notifications-page">
      <NotificationsPage />
    </div>
  );
}
